


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getOrderDetailPage } from '@/api/order'

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = this.defaultActivity || 0

  @Watch('defaultActivity')
  private onChange(val) {
    this.activeIndex = Number(val)
  }

  get changedOrderList() {
    return [
      // {
      //   label: '全部预约',
      //   value: 0
      // },
      {
        label: '待审核',
        value: 1,
        num: this.orderStatics.toBePass
      },
      {
        label: '审核通过',
        value: 2,
        num: this.orderStatics.pass
      },
      {
        label: '审核未通过',
        value: 3,
        num: this.orderStatics.notPass
      }
    ]
  }

  private tabChange(activeIndex) {
    this.activeIndex = activeIndex
    this.$emit('tabChange', activeIndex)
  }
}
